<template>
  <div class="check-progress">
    <label>{{$t('root.filters.checklist_progress')}}</label>

    <input v-model="min" placeholder='min %' class="form-control" v-on:keydown.enter.prevent="filter" />
    <input v-model="max" placeholder='max %' class="form-control" v-on:keydown.enter.prevent="filter" />

    <div class="float-right">
      <button class="btn-sm btn btn-neutral m-r-10" @click.prevent="$emit('cancel')">{{ $t('root.filters.cancel') }}</button>
      <button class="btn-sm btn btn-primary" @click.prevent='filter'>{{ $t('root.filters.apply') }}</button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      min: null,
      max: null,
    }
  },
  computed: {
    parsedMin() {
      return parseFloat(this.min)
    },
    parsedMax() {
      return parseFloat(this.max)
    },
  },
  methods: {
    filter() {
      let newQuery = Object.assign({}, this.query)

      delete newQuery['filters[contact_data_checklist_progress_gteq]']
      delete newQuery['filters[contact_data_checklist_progress_lteq]']

      if (this.parsedMin)
        newQuery = Object.assign({}, newQuery, { page: 1,'filters[contact_data_checklist_progress_gteq]': this.parsedMin })

      if (this.parsedMax)
        newQuery = Object.assign({}, newQuery, { page: 1, 'filters[contact_data_checklist_progress_lteq]': this.parsedMax})

      this.$router.push({ query: newQuery })
    },
  }
}
</script>
<style lang="sass" scoped>
.check-progress
  width: 200px
  padding: 10px
.float-right
  margin-top: 15px
</style>
